import { useEffect, useState } from "react";
import { Table, Form, Modal, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import API from "../api";

const GestionSalidas = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [fechaDesvinculacion, setFechaDesvinculacion] = useState("");
  const [articulo, setArticulo] = useState("");
  const [mesAviso, setMesAviso] = useState(false);
  const [formaPago, setFormaPago] = useState("");
  const [resultadoFiniquito, setResultadoFiniquito] = useState(null);
  const [vacacionesRestantes, setVacacionesRestantes] = useState(0);
  const [solicitudesUsuario, setSolicitudesUsuario] = useState([]);
  const [mostrarAlertaDespido, setMostrarAlertaDespido] = useState(false);

  useEffect(() => {
    const obtenerUsuarios = async () => {
      try {
        const res = await axios.get(`${API}/usuarios`);
        setUsuarios(res.data);
      } catch (err) {
        console.error("Error al cargar usuarios:", err);
      }
    };
    obtenerUsuarios();
  }, []);

  const usuariosFiltrados = usuarios.filter((u) => {
    const termino = busqueda.toLowerCase();
    return (
      u.Nombre?.toLowerCase().includes(termino) ||
      u.Usuario?.toLowerCase().includes(termino) ||
      u.RUT?.toLowerCase().includes(termino)
    );
  });

  const abrirModal = async (usuario) => {
    setUsuarioSeleccionado(usuario);
    setMostrarModal(true);
    setResultadoFiniquito(null);
    try {
      const res = await axios.get(`${API}/solicitudes_rrhh/${usuario.Usuario}`);
      setSolicitudesUsuario(res.data);
      const vacaciones = calcularVacaciones(usuario.FechaIngreso, res.data);
      setVacacionesRestantes(vacaciones);
    } catch (err) {
      console.error("Error al obtener solicitudes del usuario:", err);
      setVacacionesRestantes(0);
    }
  };

  const [causales, setCausales] = useState([]);

  useEffect(() => {
    const obtenerCausales = async () => {
      try {
        const res = await axios.get(`${API}/articulos_despido`);
        setCausales(res.data);
      } catch (err) {
        console.error("Error al cargar causales:", err);
      }
    };
    obtenerCausales();
  }, []);

  const contarDiasHabiles = (inicioStr, finStr) => {
    const [diaI, mesI, anioI] = inicioStr.split("/");
    const [diaF, mesF, anioF] = finStr.split("/");
    const inicio = new Date(`${anioI}/${mesI}/${diaI}`);
    const fin = new Date(`${anioF}/${mesF}/${diaF}`);
    let diasHabiles = 0;
    for (let d = new Date(inicio); d <= fin; d.setDate(d.getDate() + 1)) {
      const diaSemana = d.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) diasHabiles++;
    }
    return diasHabiles;
  };

  const calcularVacaciones = (fechaIngresoStr, solicitudes = []) => {
    if (!fechaIngresoStr) return 0;
    const [dia, mes, anio] = fechaIngresoStr.split("/");
    const fechaIngreso = new Date(`${anio}-${mes}-${dia}`);
    const hoy = new Date();
    const totalMeses = (hoy.getFullYear() - fechaIngreso.getFullYear()) * 12 + (hoy.getMonth() - fechaIngreso.getMonth());
    // const acumuladas = Math.floor(totalMeses * 1.25);
    const acumuladas = Math.ceil(totalMeses * 1.25);
    const diasTomados = solicitudes
      .filter(s => s.Estado === "Aprobado" && s.TipoSolicitud === "Vacaciones")
      .reduce((total, s) => total + contarDiasHabiles(s.FechaInicio, s.FechaFin), 0);
    return acumuladas - diasTomados;
  };

  const calcularFiniquito = () => {
    if (!usuarioSeleccionado || !fechaDesvinculacion || !usuarioSeleccionado.FechaIngreso) return;
    const hoy = new Date();
    const diaDelMes = hoy.getDate();
    const sueldoBase = usuarioSeleccionado.SueldoBase || 0;
    const sueldoPendiente = Math.round((sueldoBase / 30) * diaDelMes);
    const vacaciones = Math.round((sueldoBase / 30) * vacacionesRestantes);
    const [dia, mes, anio] = usuarioSeleccionado.FechaIngreso.split("/");
    const ingresoDate = new Date(`${anio}-${mes}-${dia}`);
    const finDate = new Date(fechaDesvinculacion);
    const aniosTrabajados = finDate.getFullYear() - ingresoDate.getFullYear();
    const aniosServicio = Math.max(aniosTrabajados, 0) * sueldoBase;
    const avisoPrevio = mesAviso ? 0 : sueldoBase;
    const total = sueldoPendiente + vacaciones + aniosServicio + avisoPrevio;
    setResultadoFiniquito({ sueldoPendiente, vacaciones, aniosServicio, avisoPrevio, total });
  };

    const limpiarFormulario = () => {
    setUsuarioSeleccionado(null);
    setFechaDesvinculacion("");
    setArticulo("");
    setMesAviso(false);
    setFormaPago("");
    setResultadoFiniquito(null);
    setVacacionesRestantes(0);
    setSolicitudesUsuario([]);
    };


  const realizarDespido = () => {
    setMostrarAlertaDespido(true);
  };

  return (
    <div className="container py-4">
      <Form.Control
        type="text"
        placeholder="Buscar por Nombre, Usuario o RUT"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        className="mb-4"
      />

      <Table striped bordered hover responsive className="text-center align-middle">
        <thead className="table-dark">
          <tr>
            <th>Nombre</th>
            <th>Usuario</th>
            <th>RUT</th>
          </tr>
        </thead>
        <tbody>
          {usuariosFiltrados.map((u) => (
            <tr key={u._id} style={{ cursor: "pointer" }} onClick={() => abrirModal(u)}>
              <td>{`${u.Nombre} ${u["Apellido Paterno"]} ${u["Apellido Materno"]}`}</td>
              <td>{u.Usuario}</td>
              <td>{u.RUT || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal Finiquito */}
      <Modal show={mostrarModal} onHide={() => setMostrarModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>🧾 Calcular Finiquito</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {usuarioSeleccionado && (
            resultadoFiniquito ? (
              <>
                <h5 className="fw-bold text-center fs-4 mb-3">Resultado del Pre-Finiquito</h5>
                <hr className="mb-4" />
                <Table striped bordered hover responsive className="text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Concepto</th>
                      <th>Detalle</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Sueldo pendiente del mes</td>
                      <td>{`(Sueldo / 30) * días del mes trabajados`}</td>
                      <td>{resultadoFiniquito.sueldoPendiente.toLocaleString("es-CL")} CLP</td>
                    </tr>
                    <tr>
                      <td>Vacaciones proporcionales</td>
                      <td>{`(Sueldo / 30) * días vacaciones restantes`}</td>
                      <td>{resultadoFiniquito.vacaciones.toLocaleString("es-CL")} CLP</td>
                    </tr>
                    <tr>
                      <td>Años de servicio</td>
                      <td>{`Años completos trabajados * sueldo base`}</td>
                      <td>{resultadoFiniquito.aniosServicio.toLocaleString("es-CL")} CLP</td>
                    </tr>
                    <tr>
                      <td>Mes de aviso</td>
                      <td>{mesAviso ? "Mes aviso cumplido = 0" : "No aviso = sueldo base completo"}</td>
                      <td>{resultadoFiniquito.avisoPrevio.toLocaleString("es-CL")} CLP</td>
                    </tr>
                    <tr className="fw-bold">
                      <td>Total</td>
                      <td></td>
                      <td>{resultadoFiniquito.total.toLocaleString("es-CL")} CLP</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <>
                <h5 className="fw-bold text-center fs-4 mb-3">{`${usuarioSeleccionado.Nombre} ${usuarioSeleccionado["Apellido Paterno"]} ${usuarioSeleccionado["Apellido Materno"]}`}</h5>
                <hr className="mb-4" />
                <p className="fw-semibold">Escoge la causa de la finalización del vínculo laboral</p>
                <Form>
                  <Row className="mb-3">
                    <Col md={9}>
                      <Form.Group className="mb-4">
                        <Form.Select value={articulo} onChange={(e) => setArticulo(e.target.value)}>
                          <option value="">Seleccionar artículo y causal...</option>
                          {causales.map((item, idx) => (
                            <option key={idx} value={`Artículo ${item.Articulo} - ${item.Causal}`}>
                              Artículo {item.Articulo} - {item.Causal}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <p className="fw-semibold">Ingresar fecha de término</p>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Fecha de Ingreso</Form.Label>
                        <Form.Control type="text" disabled value={usuarioSeleccionado.FechaIngreso || "-"} />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Fecha de Fin de Contrato</Form.Label>
                        <Form.Control type="date" value={fechaDesvinculacion} onChange={(e) => setFechaDesvinculacion(e.target.value)} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Sueldo Base</Form.Label>
                        <Form.Control type="text" disabled value={`${Number(usuarioSeleccionado.SueldoBase || 0).toLocaleString("es-CL")} CLP`} />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Días de Vacaciones Restantes</Form.Label>
                        <Form.Control type="text" disabled value={`${vacacionesRestantes} días`} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Check
                    type="checkbox"
                    label="Mes de aviso cumplido"
                    checked={mesAviso}
                    onChange={() => setMesAviso(!mesAviso)}
                    className="mb-3"
                  />
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Forma de Pago</Form.Label>
                        <Form.Select value={formaPago} onChange={(e) => setFormaPago(e.target.value)}>
                          <option value="">Seleccionar...</option>
                          <option value="Transferencia">Transferencia</option>
                          <option value="Cheque">Cheque</option>
                          <option value="Efectivo">Efectivo</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </>
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          {resultadoFiniquito ? (
            <>
              <Button variant="secondary" onClick={() => setResultadoFiniquito(null)}>Volver</Button>
              <Button variant="outline-danger" onClick={() => { setMostrarModal(false); limpiarFormulario();}}>Cancelar</Button>
              <Button variant="success" onClick={realizarDespido}>Realizar Despido</Button>
            </>
          ) : (
            <>
              <Button variant="secondary" onClick={() => { setMostrarModal(false); limpiarFormulario();}}>Cerrar</Button>
              <Button variant="primary" onClick={calcularFiniquito}>Calcular Pre-Finiquito</Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Modal de Confirmación */}
      <Modal show={mostrarAlertaDespido} onHide={() => setMostrarAlertaDespido(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>⚠️ Confirmar Despido</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="fs-5">Estas a punto de desvincular a <strong>{usuarioSeleccionado?.Nombre} {usuarioSeleccionado?.["Apellido Paterno"]}</strong>.</p>
          <p className="text-danger fw-bold">¿Deseas continuar?</p>
          <p className="text-muted">Se eliminará toda la información relacionada a esta persona.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarAlertaDespido(false)}>Cancelar</Button>
          <Button variant="danger">Confirmar Despido</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GestionSalidas;
